import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationAffiliatePost = {
    path: "/affiliate",
    method: ERouteHttpVerb.POST
};
export { routeLocationAffiliatePost };
